/** The type pill (`header.pills.type`, deliverable 17): the page's type, one click from changing it. */
import type { SlotComponentProps } from '@codex/contracts';
import { Pill, TypeChip, TypeGlyph } from '@codex/ui';
import { useState } from 'react';
import { isLook } from '../model/types-view.js';
import { useDocFields } from './doc-fields.js';
import { RetypeDialog } from './RetypeDialog.js';
import '../types.css';
import './pills.css';

export function TypePill({ docId }: SlotComponentProps) {
  const { doc, types, refreshDoc, reload } = useDocFields(docId);
  const [open, setOpen] = useState(false);
  if (!doc) return null;
  const type = types.find((t) => t.id === doc.typeId);
  const name = type?.name ?? doc.typeKey;
  const look = type && isLook(type.icon) ? type.icon : 'note';
  // A reference or trashed page shows its type and offers no change.
  if (doc.library === 'reference' || doc.deletedAt !== null) {
    return (
      <Pill icon={<TypeGlyph type={look} size={14} />}>
        Type: {name}
        {doc.deletedAt !== null ? ' (in the trash)' : ' (reference)'}
      </Pill>
    );
  }
  return (
    <>
      <TypeChip
        type={look}
        typeLabel="Type"
        title={name}
        preview={false}
        size="sm"
        onOpen={() => setOpen(true)}
      />
      {open && type && (
        <RetypeDialog
          doc={doc}
          types={types}
          onClose={() => setOpen(false)}
          refreshDoc={refreshDoc}
          reload={reload}
        />
      )}
    </>
  );
}
